module.exports = __webpack_public_path__ + "static/media/5f8de7ed5ae7590275f07521_banner_800x600.ea71997c.png";